export enum ENUM__ui_theme {
  SYSTEM = 'system',
  LIGHT = 'light',
  DARK = 'dark',
}
